import type { LifecycleEvent, LifecycleObserver } from './chain';
import { getLogger } from '../logging/logger';

/**
 * Built-in observer that emits a structured log line for each lifecycle
 * event coming out of `@whittlelabs/jobs`' subscribe loop. Always first in
 * the chain so we capture even a spend-veto.
 */
export function createLoggerObserver(): LifecycleObserver {
  return {
    name: 'logger',
    async notify(event: LifecycleEvent): Promise<void> {
      const logger = getLogger();
      switch (event.kind) {
        case 'job.claimed':
          logger.info('Job claimed', {
            jobId: event.jobId,
            attendanceId: event.attendanceId,
            attempt: event.attempt,
          });
          return;
        case 'spend.preflight':
          logger.debug('Spend preflight', { jobId: event.jobId });
          return;
        case 'executor.dispatch.started':
          logger.debug('Executor dispatch started', {
            jobId: event.jobId,
            executor: event.executor,
          });
          return;
        case 'executor.dispatch.completed':
          logger.info('Executor dispatch completed', {
            jobId: event.jobId,
            executor: event.executor,
            durationMs: event.durationMs,
          });
          return;
        case 'output.submitted':
          logger.debug('Output submitted', { jobId: event.jobId, label: event.label });
          return;
        case 'attendance.closed':
          logger.info('Attendance closed', {
            jobId: event.jobId,
            status: event.status,
            reason: event.reason,
            totalDurationMs: event.totalDurationMs,
          });
          return;
      }
    },
  };
}
